import React, { useState } from 'react';
import styles from './TemplatesSection.module.css';
import Categories from './Categories/Categories';
import {
    TemplateCategoryEnum,
    TemplateCategoryType,
} from '@shared/Enums/TemplateCategoryEnum';
import BasicSwitcher from '../../../../../Shared/Ui/Switchers/BasicSwitcher/BasicSwitcher';
import { useTemplatesViewModel } from '@viewModels/TemplatesViewModel/TemplatesViewModel';

const TemplatesSection = () => {
    const [category, setCategory] = useState<TemplateCategoryType>(
        TemplateCategoryEnum.All
    );
    const { templatesCategories } = useTemplatesViewModel();

    const labels = Object.values(TemplateCategoryEnum).filter(
        label => label !== TemplateCategoryEnum.HousePlans
    );
    const activeIndex = labels.indexOf(category);

    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        const index =
            Array.from(event.currentTarget.children).indexOf(
                event.target as HTMLElement
            ) - 1;
        if (index >= 0 && index < labels.length) {
            setCategory(labels[index] as TemplateCategoryType);
        }
    };

    const markerLeftPosition =
        activeIndex === 0
            ? '6px'
            : activeIndex === labels.length - 1
              ? 'calc(75% - 6px)'
              : `${activeIndex * 25}%`;

    const filteredCategories = templatesCategories.filter(cat => {
        if (cat.category === TemplateCategoryEnum.HousePlans) {
            return false;
        }

        if (category === TemplateCategoryEnum.All) {
            return true;
        }

        return cat.category === category;
    });

    return (
        <section className={styles.section}>
            <BasicSwitcher
                labels={labels}
                activeIndex={activeIndex}
                onClick={handleClick}
                className={styles.switcher}
                labelClassName={styles.switcherLabel}
                activeLabelClassName={styles.switcherLabelActive}
                markerClassName={styles.switcherMarker}
                markerStyle={{
                    position: 'absolute',
                    left: markerLeftPosition,
                    transition: 'left 0.3s ease-in-out',
                }}
            />

            <div className={styles.templateSectionContentCategory}>
                {filteredCategories.length > 0 ? (
                    filteredCategories.map(category => (
                        <Categories key={category.id} category={category} />
                    ))
                ) : (
                    <div className={styles.error}>
                        No templates were found for this category
                    </div>
                )}
            </div>
        </section>
    );
};

export default TemplatesSection;
